
import React, { useState } from 'react';

function Ship(props) {
  const [currentDeck, setCurrentDeck] = useState();

  function renderCurrentDeck() {
    
    if (props.ship.decks.length === 0) {
      return null;
    }

    let deckNumber = currentDeck;
    if (!currentDeck) {
      deckNumber = props.ship.decks[0].deckNumber;
      setCurrentDeck(deckNumber);
    }
    const deck = props.ship.decks.find(x => x.deckNumber === deckNumber);
    return <div>
      {deck
        ? <img alt={deck.deckNumber} src={props.pictureserver + deck.decoMapImg} />
        : <span>NoImg</span>
      }

    </div>
  }
  function decks(decks) {
    if (decks) {

      return (
        <div>
          <div className="flex flex-wrap justify-around">
            {decks.map((deck) =>
              <React.Fragment key={deck.deckNumber}>
                <div onClick={() => setCurrentDeck(deck.deckNumber)}
                  className="max-w-sm p-2 flex items-center cursor-pointer hover:bg-secondary-button-hover" >
                  <div
                    className="text-center">
                    <div>Deck {deck.deckNumber}</div>
                    {deck.name != "Deck " + deck.deckNumber
                      ?
                      <div
                        className={deck.deckNumber === currentDeck
                          ? "text-xs font-semibold border-b-4 border-cruise_orange"
                          : "text-xs"}>
                        ({deck.name})
                      </div>
                      : null}
                  </div>
                </div>
              </React.Fragment>
            )}
            {renderCurrentDeck()}
          </div>
        </div>
      );
    }
  }

  function gallery(gallery) {
    if (gallery) {
      return (
        <div>
          {gallery.map((type) =>
            <div key={type.imageSubType} id="shipgallery" >
              <div className="text-center py-8"><span className="text-xl font-semibold">{type.imageSubType}</span></div>
              <React.Fragment>
                {type.images.map((pic) =>
                  <div key={pic.sequence} className="flex my-3 ">
                    <div className="w-full" style={{ maxHeight: 300, maxWidth: 300 }}>
                      <img alt="Shipgallery" src={props.pictureserver + pic.filePath} />
                    </div>
                    <div className="px-3 w-full">
                      <span className="cursor-pointer text-lg">{pic.title}</span>
                      <p className="p-3">{pic.description}</p>
                    </div>
                  </div>
                )}
              </React.Fragment>
            </div>
          )}
        </div>
      );
    }
  }

  if (props.ship) {

    const styledImage = {
      backgroundImage: `linear-gradient(to top, rgba(159,211,223, 1), rgba(159,211,223, 0) 80%)`,
      backgroundPosition: 'center',
      backgroundSize: 'cover'
    };
    return (
      <div className="px-4">
        <div className="flex justify-center text-xl p-2">
          <div className="pr-2">Your operator:</div>
          <div >{props.ship.cruiseline.name}</div>
        </div>
        <div className="flex justify-center text-xl p-2">
          <div className="pr-2">Your ship:</div>
          <div >{props.ship.name}</div>
        </div>
        <div style={styledImage} className="">
          <img className="relative w-full" style={{ zIndex: -1 }} alt="ship" src={props.pictureserver + props.ship.image} />
        </div>
        <div className="my-3" style={{ whiteSpace: 'pre-line' }}>{props.ship.description}</div>
        <div className="text-center p-8">
          <span className="text-xl font-semibold">Deckplan</span>
        </div>
        {decks(props.ship.decks)}
        {gallery(props.ship.gallery)}
      </div>
    )
  }
}

export default Ship;